import { useState } from "react"
import { DashboardReportFolioContext } from "../context"
import { FilterProps } from "../../../../../hooks/filter/typing"
import { useFilter } from "../../../../../hooks/filter"
import { generateInform } from "../pages/main/methods"

const DashboardReportFolioProvider = (props: { children: JSX.Element }) => {
    const [filterPayload, setFilterPayload] = useState<FilterProps>({ formatFilter: {} })
    const filterData = useFilter(filterPayload)
    const [isLoading, setIsLoading] = useState(false)
    const [uuid, setUuid] = useState('')
    const getDetailInform = async ({ query }: { query?: string }) => {
        if (!uuid) {
            const response = await generateInform(undefined, query);
            if (response.uuid) {
                setUuid(response.uuid)
                setIsLoading(true)
            }
        } else {
            const response = await generateInform(uuid, undefined);
            if (response.reportUrl) {
                setUuid('')
                fetch(response.reportUrl)
                    .then(res => res.blob()) // Convierte la respuesta en un blob
                    .then(blob => {
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'reporte.pdf'); // Puedes cambiar el nombre del archivo
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(url); // Limpia el objeto URL
                    })
                    .catch(err => console.error('Error al descargar el archivo:', err))
                    .finally(() => {
                        setIsLoading(false);
                        window.open(response?.reportUrl ?? '');
                    });
            }
        }
    }

    return (
        <DashboardReportFolioContext.Provider
            value={{ filterData, setFilterPayload, isLoading, uuid, getDetailInform }}
        >{props.children}
        </DashboardReportFolioContext.Provider>
    )
}

export { DashboardReportFolioProvider }
